import Logo from 'src/components/Logo'
import {
  GrowthSlot,
  GrowthSlotName,
  type GrowthSlotProps,
} from '../growth-slot'
import { cn } from '~/utils/cx'

export function AppLogoSlot({
  className,
  ...props
}: Omit<GrowthSlotProps, 'name'>) {
  return (
    <GrowthSlot
      {...props}
      name={GrowthSlotName.AppLogo}
      className={cn('contents', className)}
    >
      <Logo className="size-full" />
    </GrowthSlot>
  )
}
